import React, { useState } from "react";
import { Modal, Form, DatePicker, Upload, notification, message } from "antd";
import axiosInstance from "utilities/axios";
const UploadCalibration = ({ id, open, onClose, onUpdate }) => {
  const [form] = Form.useForm();
  const [calibrationSavedLoading, setCalibrationSavedLoading] = useState(false);
  const handleCalibrationSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const { file, calibrationDate } = values;

        setCalibrationSavedLoading(true);
        const formData = new FormData();

        formData.append("file", file.file);
        formData.append(
          "calibrationDate",
          calibrationDate.format("YYYY-MM-DD HH:mm:ss")
        );
        formData.append("equipmentId", id);

        axiosInstance
          .post(`/equipment/calibrations`, formData)
          .then((response) => {
            notification.success({
              message: "Success",
              description: "Calibration certificate uploaded successfully!",
            });
            onUpdate();
            onClose();
          })
          .catch((error) => {
            notification.error({
              message: "Error",
              description: error.message,
            });
          })
          .finally(() => {
            setCalibrationSavedLoading(false);
          });
      })
      .catch((error) => {
        message.error("Please fix the errors in the form");
      });
  };

  return (
    <Modal
      title="Add Calibration"
      open={open}
      onCancel={onClose}
      okText="Save"
      //override the loading of the ok button
      okButtonProps={{ loading: calibrationSavedLoading }}
      onOk={handleCalibrationSubmit}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="file" label="Upload Certificate">
          <Upload.Dragger
            action="/upload.do"
            listType="text"
            beforeUpload={() => false}
            multiple={false}
            maxCount={1}
          >
            <p className="ant-upload-text">
              Drag & drop certificate or click to upload
            </p>
          </Upload.Dragger>
        </Form.Item>
        <Form.Item
          label="Calibration Date"
          name="calibrationDate"
          rules={[
            { required: true, message: "Please select calibration date" },
            // calibrations should be in the past or today
            {
              validator: (_, value) => {
                if (value.isAfter()) {
                  return Promise.reject(
                    "Calibration date should be today or in the past"
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <DatePicker />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UploadCalibration;
